import React from 'react'
import {Link} from 'react-router-dom'
import CheckIcon from '../../../../media/felsv/CheckIcon.svg'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionComprobanteRetencionEmision} from '../../../../actions/action-creators'

const CREFooterResumen = () => {
  const disptach = useDispatch()
  const {comprobanteRetencionClicEmitirFactura} = bindActionCreators(actionComprobanteRetencionEmision, disptach )

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div className='card'>
        <div className='w-layout-vflex card-content'>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%', }} >
            <Link to='/otros-documentos/comprobante-retencion/formulario' className='m button transparent botton-footer' >
              <div>Regresar</div>
            </Link>
            <button className='m button botton-footer' onClick={comprobanteRetencionClicEmitirFactura}>
              <div>Emitir</div>
              <img src={CheckIcon} loading='lazy' alt='Emitir' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CREFooterResumen
